import { render } from "./companyCardQuota.vue?vue&type=template&id=0bb38a89&scoped=true"
import script from "./companyCardQuota.vue?vue&type=script&lang=js"
export * from "./companyCardQuota.vue?vue&type=script&lang=js"

import "./companyCardQuota.vue?vue&type=style&index=0&id=0bb38a89&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0bb38a89"

export default script